import React, {useEffect, useState} from 'react';
import {VideoPlayer} from "../components/video-player/video-player";
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import {InDemandIcon} from "../components/icons/indemand-icon";
import CssBaseline from '@material-ui/core/CssBaseline';
import {makeStyles} from "@material-ui/core/styles";
import {SkipToClassic} from "../components/common/skip-to-classic";
import {BuyYourTicketButton} from "../components/common/buy-your-ticket-button";
import {LiveInCountdown} from "../components/common/live-in-countdown";
import moment from "moment";
import {hologramIconsStreams, hologramIconsTrailers} from "../consts/hologram-icons";
import Button from "@material-ui/core/Button";
import {iOS} from '../consts/ios';

const useStyles = makeStyles((theme) => ({
    root: {
        color: '#ffb615',
        width: '100%',

        '& h3, & h4, & h5, & h6, & a': {
            color: '#ffb615'
        },
        '& h4': {
            color: '#ffb615'
        },
        '& svg': {
            fill: '#ffb615'
        }
    },
    typography: {
        [theme.breakpoints.down('lg')]: {},
        '& h4': {
            fontSize: '2vw',
        },
        '& h3': {
            fontSize: '4vw',
        }
    }
}));

export const ShowLanding = () => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tickets, setTickets] = useState(null);
    const [userSubscriptions, setUserSubscriptions] = useState(window.user && window.user.hasActiveSubscriptions());
    const [user, setUser] = useState(window.user || undefined);
    const [isUserLoading, setUserIsLoading] = useState(false);
    const [isUserLoaded, setUserIsLoaded] = useState(false);
    const [forceShowMode, setForceMode] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (tickets || isLoading || isLoaded) return;
        setIsLoading(true);
        (async () => {
            try {
                const response = await fetch("/tickets/user-tickets", {
                    "headers": {
                        "accept": "application/json, text/javascript, */*; q=0.01",
                    },
                    "method": "GET",
                });
                if (response.ok) {
                    const data = await response.json();
                    setTickets(data);
                    setUserSubscriptions(window.user ? window.user.hasActiveSubscriptions() : false);
                }
            } catch (err) {
                setIsError(true);
            }
        })();

        setIsLoading(false);
        setIsLoaded(true);
    }, []);
    useEffect(() => {
        if (user !== undefined) return;
        if (isUserLoading) return;
        if (isUserLoaded) return;
        (async () => {
            setUserIsLoading(true);
            try {
                const response = await fetch("/user/info", {
                    "headers": {
                        "accept": "application/json, text/javascript, */*; q=0.01",
                    },
                    "method": "GET",
                });
                if (response.ok) {
                    const data = await response.json() || {subscriptions: []};
                    console.log(data);

                    setUser(data);
                    let hasActiveSubscriptions = false;
                    for (let i in data.subscriptions) {
                        if (data.subscriptions[i].state * 1 === 1) {
                            hasActiveSubscriptions = true;
                            break;
                        }
                    }

                    setUserSubscriptions(hasActiveSubscriptions);
                }
            } catch (err) {
                console.error(err);
                setUser(null);
            }
            setUserIsLoaded(true);
            setUserIsLoading(false);
        })();

    }, []);

    useEffect(() => {
        let interval = setInterval(() => {
            if (window.user && window.user.group_id === "1") {
                setIsAdmin(true);
                clearInterval(interval);
            }
            if (window.user && window.user.id && window.user.group_id !== "1") {
                clearInterval(interval); // stop polling
            }
        }, 1e3);

        return () => clearInterval(interval);
    }, []);
    const [videoJsOptions, setVideoJsOptions] = useState({
        autoplay: true,
        controls: true,
        liveui: true,
        playlist: hologramIconsTrailers
    });
    const [channel] = useState({
        streams: hologramIconsStreams
    });

    const enableImage = false;
    const startDate = 'Fri, 18 Sep 2020 19:00:00 EDT';
    const liveEndDate = 'Fri, 18 Sep 2020 21:00:00 EDT';
    const dateFormat = undefined;

    const [isShowMode, setIsShowMode] = useState(false);

    const show = {
        startDate,
        liveEndDate,
        isLiveNow: true || +moment(startDate, dateFormat).toDate() < (+new Date()) &&
            +moment(liveEndDate, dateFormat).toDate() > (+new Date()),
        isFinished: false ||  +moment(liveEndDate, dateFormat).toDate() < (+new Date()),
        isStarted: true || +moment(startDate, dateFormat).toDate() < (+new Date())
    };

    useEffect(() => {
        let isStarted = true || +moment(startDate, dateFormat).toDate() < (+new Date());
        if ((!userSubscriptions || !isStarted) && !forceShowMode) return;

        // user has subscriptions and show is started. Autostart  live stream then;
        setVideoJsOptions({
            ...videoJsOptions,
            playlist: undefined,
            sources: channel.streams.map(source => ({
                src: source.url,
                type: iOS ? 'application/vnd.apple.mpegurl' : 'application/x-mpegurl',
                label: source.quality === 'low' ? '480p' : '720p'
            })),
            vr: true,
            // panorama: true,
            debug: true,
            forceCardboard: true,
            projection: "NONE",
            forceLandscape: true
        });
        setIsShowMode(true);
    }, [isShowMode, userSubscriptions, channel, forceShowMode]);


    return (<section className={classes.root}>
        <Grid container justify="space-around" direction="row" spacing={4}>
            <Grid item xs={8}>
                <SkipToClassic className={classes.typography}/>
            </Grid>
            <Grid item xs={4} >
                {isAdmin && <Button variant={'text'} onClick={() => setForceMode(true)}
                                    title={"This is allowed for admin users only"}
                >
                    Force show mode<sup>*</sup>
                </Button>
                }

            </Grid>

            <Grid item xs={8} sm={8} md={6} lg={6} xl={6} style={{textAlign: 'center'}}>
                <Grid container>
                    <Grid item xs={enableImage ? 6 : 12} className={classes.typography}>
                        <Typography variant={'h4'}>
                            Live from Swissx Island
                        </Typography>
                        <Typography variant={'h4'}>
                            Scott Storch presents
                        </Typography>
                        <Typography variant={'h3'} style={{fontWeight: 'bold'}}>
                            HOLOGRAM ICONS
                        </Typography>
                    </Grid>
                    {enableImage && (<Grid item xs={6}>
                        <img style={{width: '100%'}} src='/hologram-icons/poster.jpg' alt={"Hologram Icons Poster"}/>
                    </Grid>)}
                </Grid>
            </Grid>

            <CssBaseline/>

            <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
                <Grid container>
                    <Grid item xs={8} style={{display: 'none'}}>
                        <Typography variant={'h4'}>
                            LIVE on <InDemandIcon style={{verticalAlign: 'middle'}}/> and
                            <img style={{verticalAlign: 'middle', height: '40px'}}
                                 src={"https://static.filmon.com/theme/img/filmon_small_logo.png"}
                                 title={"Filmon.Com"} alt={'filmon logo'}/>
                        </Typography>
                        <Typography variant={'h4'}>
                            September 18th @ 7 PM EST
                        </Typography>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'center', width: '100%', maxWidth: '100%', flexBasis: '100%'}}>
                        {!userSubscriptions ? <BuyYourTicketButton/> : <h4> Your ticket is active!</h4>}

                        {/*{!show.isStarted && <LiveInCountdown toDate={show.startDate} toDateFormat={dateFormat}*/}
                        {/*                                     endDate={show.liveEndDate}*/}
                        {/*                                     onCountdownEnd={() => window.location.reload()}*/}
                        {/*/>}*/}
                        {
                            show.isLiveNow && <Typography variant={'h6'} style={{fontSize: '2em'}}>
                                watch replay
                            </Typography>
                        }
                        {/*{*/}
                        {/*    show.isFinished && <Typography variant={'h6'} style={{fontSize: '2em'}}>*/}
                        {/*        Replay*/}
                        {/*    </Typography>*/}
                        {/*}*/}
                    </Grid>
                </Grid>
            </Grid>

            <CssBaseline/>

            <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
                {!isShowMode && <VideoPlayer {...videoJsOptions} />}
                {/*to force re-render videoPlayer*/}
                {isShowMode && <VideoPlayer {...videoJsOptions} />}
            </Grid>

            <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
                {/*<div className="vjs-playlist"></div>*/}
            </Grid>

            <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
            </Grid>

        </Grid>
    </section>);
}
